<app-toolbar
  [backButtonLabel]="backButtonLabel"
  [backButtonTask]="navigateBackTask"
  [title]="title"
  [description]="description"
></app-toolbar>
<div *ngIf="loading" class="spinner-container">
  <p-progressSpinner styleClass="bw-spinner"></p-progressSpinner>
  <span class="spinner-text">Lade Daten...</span>
</div>
<div class="supplier-analytics-container">
  <div class="supplier-analytics-table-container">
    <p-table
      #dt
      [columns]="selectedColumns"
      [value]="suppliersAnalytics"
      [scrollable]="true"
      [rowHover]="true"
      sortMode="multiple"
      [multiSortMeta]="[
        { field: 'supplier.id', order: 1 },
        { field: 'year', order: -1 }
      ]"
      scrollHeight="70vh"
      rowGroupMode="subheader"
      groupRowsBy="supplier.id"
      [tableStyle]="{ 'min-width': '50rem' }"
      [paginator]="true"
      [rows]="100"
      [rowsPerPageOptions]="[100, 500, 1000, 2000, 5000]"
      [showCurrentPageReport]="true"
      [globalFilterFields]="['supplier.id', 'supplier.name', 'year']"
    >
      <ng-template #header let-columns>
        <tr>
          <th style="min-width: 15rem" pSortableColumn="year">
            <div style="display: flex; align-items: center">
              Jahr
              <p-sortIcon field="name" />
              <p-columnFilter
                field="year"
                matchMode="in"
                display="menu"
                [showMatchModes]="false"
                [showOperator]="false"
                [showAddButton]="false"
                [showApplyButton]="false"
                style="margin-left: auto"
              >
                <ng-template #filter let-value let-filter="filterCallback">
                  <p-multiselect
                    [(ngModel)]="selectedYears"
                    [options]="years"
                    placeholder="Alle Jahre"
                    (ngModelChange)="onYearsChange($event, filter)"
                    [style]="{ 'min-width': '14rem' }"
                    [panelStyle]="{ minWidth: '16rem' }"
                  >
                    <ng-template let-option pTemplate="item">
                      <div class="flex items-center gap-2">
                        <span>{{ option }}</span>
                      </div>
                    </ng-template>
                  </p-multiselect>
                </ng-template>
              </p-columnFilter>
            </div>
          </th>
          <th
            style="min-width: 15rem"
            *ngFor="let col of columns"
            pSortableColumn="{{ 'data.' + col.field }}"
          >
            <div style="display: flex; align-items: center">
              {{ col.header }}
              <p-sortIcon field="{{ 'data.' + col.field }}" />
              <p-columnFilter
                type="numeric"
                field="{{ 'data.' + col.field }}"
                display="menu"
                style="margin-left: auto"
              />
            </div>
          </th>
        </tr>
      </ng-template>
      <ng-template #groupheader let-supplierAnalytics>
        <tr pRowGroupHeader>
          <td colspan="20">
            <div style="display: flex; align-items: center; gap: 0.2em">
              <span style="font-weight: bold">{{
                supplierAnalytics.supplier.name
              }}</span>
              <span>({{ supplierAnalytics.supplier.id }})</span>
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template
        #body
        let-supplierAnalytics
        let-rowIndex="rowIndex"
        let-columns="columns"
      >
        <tr>
          <td>
            {{ supplierAnalytics.year }}
          </td>
          <td *ngFor="let col of columns">
            <ng-container [ngSwitch]="col.header">
              <span *ngSwitchCase="'Warenwert Reklamation (€)'">
                {{
                  supplierAnalytics.data[col.field]
                    | currency : "EUR" : "symbol" : "1.0-2"
                }}
                <span
                  *ngIf="
                    checkPercentageValue(
                      supplierAnalytics.data[col.field + 'prct_vorjahr']
                    )
                  "
                  [ngClass]="{
                    'positive-value':
                      supplierAnalytics.data[col.field + 'prct_vorjahr'] < 0,
                    'negative-value':
                      supplierAnalytics.data[col.field + 'prct_vorjahr'] >= 0
                  }"
                  >({{
                    (supplierAnalytics.data[col.field + "prct_vorjahr"] > 0
                      ? "+"
                      : "") +
                      (supplierAnalytics.data[col.field + "prct_vorjahr"]
                        | percent : "1.2-2")
                  }})</span
                >
              </span>
              <span *ngSwitchCase="'Jahresumsatz'">
                {{
                  supplierAnalytics.data[col.field]
                    | currency : "EUR" : "symbol" : "1.0-2"
                }}
                <span
                  *ngIf="
                    checkPercentageValue(
                      supplierAnalytics.data[col.field + 'prct_vorjahr']
                    )
                  "
                  [ngClass]="{
                    'positive-value':
                      supplierAnalytics.data[col.field + 'prct_vorjahr'] >= 0,
                    'negative-value':
                      supplierAnalytics.data[col.field + 'prct_vorjahr'] < 0
                  }"
                  >({{
                    (supplierAnalytics.data[col.field + "prct_vorjahr"] > 0
                      ? "+"
                      : "") +
                      (supplierAnalytics.data[col.field + "prct_vorjahr"]
                        | percent : "1.2-2")
                  }})</span
                >
              </span>
              <span
                *ngSwitchCase="'Mittlere Verspätung (Tage)'"
                [ngClass]="{
                  'positive-value': supplierAnalytics.data[col.field] < 0,
                  'negative-value': supplierAnalytics.data[col.field] > 0
                }"
              >
                {{ supplierAnalytics.data[col.field] }}
                <span
                  *ngIf="
                    checkPercentageValue(
                      supplierAnalytics.data[col.field + 'prct_vorjahr']
                    )
                  "
                  [ngClass]="{
                    'positive-value':
                      supplierAnalytics.data[col.field + 'prct_vorjahr'] < 0,
                    'negative-value':
                      supplierAnalytics.data[col.field + 'prct_vorjahr'] >= 0
                  }"
                  >({{
                    (supplierAnalytics.data[col.field + "prct_vorjahr"] > 0
                      ? "+"
                      : "") +
                      (supplierAnalytics.data[col.field + "prct_vorjahr"]
                        | percent : "1.2-2")
                  }})</span
                >
              </span>
              <span *ngSwitchDefault>
                {{ supplierAnalytics.data[col.field] | number : "1.0-2" }}
                <span
                  *ngIf="
                    showPrevYearChangePositiveIncrease(col.field) &&
                    checkPercentageValue(
                      supplierAnalytics.data[col.field + 'prct_vorjahr']
                    )
                  "
                  [ngClass]="{
                    'positive-value':
                      supplierAnalytics.data[col.field + 'prct_vorjahr'] >= 0,
                    'negative-value':
                      supplierAnalytics.data[col.field + 'prct_vorjahr'] < 0
                  }"
                  >({{
                    (supplierAnalytics.data[col.field + "prct_vorjahr"] > 0
                      ? "+"
                      : "") +
                      (supplierAnalytics.data[col.field + "prct_vorjahr"]
                        | percent : "1.2-2")
                  }})</span
                >
                <span
                  *ngIf="
                    showPrevYearChangeNegativeIncrease(col.field) &&
                    checkPercentageValue(
                      supplierAnalytics.data[col.field + 'prct_vorjahr']
                    )
                  "
                  [ngClass]="{
                    'positive-value':
                      supplierAnalytics.data[col.field + 'prct_vorjahr'] < 0,
                    'negative-value':
                      supplierAnalytics.data[col.field + 'prct_vorjahr'] >= 0
                  }"
                  >({{
                    (supplierAnalytics.data[col.field + "prct_vorjahr"] > 0
                      ? "+"
                      : "") +
                      (supplierAnalytics.data[col.field + "prct_vorjahr"]
                        | percent : "1.2-2")
                  }})</span
                >
              </span>
            </ng-container>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
  <div
    style="
      display: flex;
      flex-direction: column;
      gap: 0.5em;
      padding: 0 1em;
      min-height: fit-content;
    "
  >
    <p-floatlabel variant="in">
      <p-iconfield iconPosition="left" style="width: 100%">
        <p-inputicon class="pi pi-search" />
        <input
          pInputText
          type="text"
          id="search_input"
          [(ngModel)]="searchValue"
          autocomplete="off"
          (input)="applyFilterGlobal($event, 'contains')"
        />
      </p-iconfield>
      <label for="search_input">Suche</label>
    </p-floatlabel>
    <p-floatlabel variant="in">
      <p-multiselect
        id="supplier_selection"
        display="chip"
        [options]="supplierOptions"
        [(ngModel)]="selectedSuppliers"
        (onChange)="onSupplierFilterChange($event, dt)"
        [virtualScroll]="true"
        [virtualScrollItemSize]="43"
        optionLabel="name"
        [style]="{ width: '100%', 'min-width': '400px' }"
        [maxSelectedLabels]="1000"
      />
      <label for="supplier_selection">Lieferant</label>
    </p-floatlabel>
    <p-floatlabel variant="in">
      <p-multiselect
        id="topic_selection"
        display="chip"
        [options]="topics"
        [(ngModel)]="selectedTopics"
        (onChange)="topicSelected($event)"
        optionLabel="label"
        selectedItemsLabel="{0} columns selected"
        [style]="{ width: '100%', 'min-width': '200px' }"
      />
      <label for="topic_selection">Topic</label>
    </p-floatlabel>
    <p-floatlabel variant="in">
      <p-multiselect
        id="column_selection"
        display="chip"
        [options]="cols"
        [(ngModel)]="selectedColumns"
        optionLabel="header"
        [style]="{ 'min-width': '200px' }"
      />
      <label for="column_selection">Spalten</label>
    </p-floatlabel>
    <p-button
      label="Zurücksetzen"
      [outlined]="true"
      icon="pi pi-filter-slash"
      (click)="clear(dt)"
      [style]="{ width: '100%', 'margin-top': '20px' }"
    />
  </div>
</div>
